module.exports = __webpack_public_path__ + "img/6.114963a7.jpg";